import { IAsset, IPaginatedREST, ResourceGroup } from '../types'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'
import { hasAdminPermission } from '../utils/resourcePermissions'

export interface IAssetList {
    /** number of itens per page */
    perPage?: number
    /** page to request page start in 0 */
    page?: number
    /** field to orderBy */
    orderBy?: string
    /** orderBy Direction */
    direction?: 'ASC' | 'DESC'
    /** This will filter by operation id */
    filterBy?: number
    /** string to search */
    keyword?: string
}

export const listAssets = async (params?: IAssetList): Promise<IPaginatedREST<IAsset>> => {
    const qs = new URLSearchParams({
        limit: params?.perPage?.toString() ?? '-1',
        offset: (Math.max(1, params?.page ?? 0) - 1)?.toString() ?? '0',
        keyword: params?.keyword?.toString() ?? '',
        orderBy: params?.orderBy?.toString()?.toUpperCase() ?? 'ID',
        direction: params?.direction?.toString() ?? 'ASC'
    }).toString()

    return fetch(
        hasAdminPermission
            ? `${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.assets}/admin/?${qs}`
            : `${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.assets}/?${qs}`,
        {
            method: 'GET',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' }
        }
    ).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error)
        }
    })
}

export const getResourceGroups = async (): Promise<ResourceGroup[]> => {
    return fetch(`services/plugin-aeapps-resources-manager/resourcegroup/`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(fetchData => {
            if (fetchData.ok) {
                return fetchData.json()
            } else {
                throw new Error(`{"status": ${fetchData.status} , "message": "${fetchData.statusText}"}`)
            }
        })
        .catch(err => {
            return JSON.parse(err.message)
        })
}
